import { Outlet, Navigate } from "react-router-dom";

const RoleAuthCheck = ({ allowedRoles, userRoleNames }) =>{
    const hasAccess = (allowedRoles[0] === '*') || allowedRoles.some((allowedRole) => userRoleNames.includes(allowedRole));
    if(hasAccess){
        return <Outlet/>
    } else {
        return <Navigate to={'/unauthorized'}/>
    }
}

export default RoleAuthCheck;